module.exports = __webpack_public_path__ + "06_medium_black.926059d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/06_medium_black.png
// module id = fbRa
// module chunks = 0